<template>
  <div id="app" class="min-h-screen bg-gray-50 dark:bg-gray-900">
    <Navigation />
    <main class="container-fluid py-8">
      <RouterView />
    </main>
    <Notifications />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useSubscriptionStore } from './stores/subscription'
import { supabase } from './services/supabase'
import Navigation from './components/Navigation.vue'
import Notifications from './components/Notifications.vue'

const router = useRouter()
const subscriptionStore = useSubscriptionStore()

onMounted(async () => {
  const { data: { session } } = await supabase.auth.getSession()
  if (!session) {
    router.push('/login')
  } else {
    await subscriptionStore.initializeUser()
  }
})
</script>

<style>
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f5f5;
}

#app {
  min-height: 100vh;
}
</style>
